import { defineMeta } from '@/registry/types';

export const sliderMeta = defineMeta({
  name: 'Slider',
  level: 'atom',
  category: 'input',
  classification: 'themed-mui',
  description: 'Selects a numeric value or range along a track. Themed MUI Slider.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Slider',
  muiDocs: 'https://mui.com/material-ui/react-slider/',
  a2uiEquivalent: 'Slider',
  importPath: '@/atoms/Slider',
  optionalProps: ['value', 'defaultValue', 'min', 'max', 'step', 'marks', 'disabled', 'valueLabelDisplay'],
  supportedStates: ['default', 'focus', 'dragging', 'disabled', 'range'],
  designTokens: ['colors'],
  accessibility: ['Provide aria-label or aria-labelledby; keyboard arrows adjust value.'],
  usageExamples: ['<Slider defaultValue={50} aria-label="Threshold" />'],
  antiPatterns: ['Do not use sliders for precise numeric entry (use TextField).'],
  llmSafe: true,
  whenToUse: ['Approximate value selection, ranges, thresholds'],
  whenNotToUse: ['Exact values requiring precision'],
});

export default sliderMeta;
